export enum ResourceStatus {
  DRAFT = -1,
  ACTIVE = -2,
  ARCHIVED = -3,
  DELETED = -4,
}
